import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=f0423b5c&scoped=true&"
import script from "./BlockForm.vue?vue&type=script&lang=js&"
export * from "./BlockForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=f0423b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0423b5c",
  null
  
)

export default component.exports